import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import List from '@material-ui/core/List';

import IconDashboard from '@material-ui/icons/Dashboard';
import IconInfo from '@material-ui/icons/Description';
import IconArticle from '@material-ui/icons/DescriptionSharp';
import IconCode from '@material-ui/icons/GitHub';
import IconAndroid from '@material-ui/icons/AndroidRounded';

import MenuIcon from '@material-ui/icons/Menu';

import Divider from '@material-ui/core/Divider';
import {
   CssBaseline,
   AppBar,
   Toolbar,
   IconButton,
   Typography,
   Hidden,
   Drawer
} from '@material-ui/core';

import AppMenuItem from './MenuItem';

const appMenuItems = [
   {
      name: 'Dashboard',
      link: '/',
      Icon: IconDashboard
   },
   {
      name: 'Divider',
      // Just add metadata
      link: '',
      Icon: IconArticle
   },
   {
      name: 'Sign Out',
      link: '/signOut',
      Icon: IconInfo
   },
   {
      name: 'Divider',
      // Just add metadata
      link: '',
      Icon: IconArticle
   },
   {
      name: 'Website Code',
      link: '/code-website',
      Icon: IconCode
   },
   {
      name: 'App Code',
      link: '/code-app',
      Icon: IconCode
   },
   {
      name: 'Download APK',
      link: '/release',
      Icon: IconAndroid
   }
];

export function MenuItems({ classes }: { classes: { toolbar: string } }) {
   return (
      <>
         {' '}
         <div className={classes.toolbar} />
         <Divider />
         <List component="nav" disablePadding>
            {appMenuItems.map((item, index) =>
               item.name !== 'Divider' ? (
                  // eslint-disable-next-line react/no-array-index-key
                  <AppMenuItem {...item} key={`${index}333a`} />
               ) : (
                  // eslint-disable-next-line react/no-array-index-key
                  <Divider key={`${index}333a`} />
               )
            )}
         </List>
      </>
   );
}

const AppMenu: React.FC = () => {
   const theme = useTheme();
   const classes = useStyles();
   const [mobileOpen, setMobileOpen] = React.useState(false);

   const handleDrawerToggle = () => {
      setMobileOpen(!mobileOpen);
   };

   const container = window != null ? () => window.document.body : null;
   return (
      <>
         <CssBaseline />
         <AppBar position="fixed" className={classes.appBar}>
            <Toolbar>
               <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  edge="start"
                  onClick={handleDrawerToggle}
                  className={classes.menuButton}
               >
                  <MenuIcon />
               </IconButton>
               <Typography variant="h6" noWrap>
                  Low Battery Notifier
               </Typography>
            </Toolbar>
         </AppBar>
         <nav className={classes.drawer} aria-label="mailbox folders">
            {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
            <Hidden smUp implementation="css">
               <Drawer
                  container={container}
                  variant="temporary"
                  anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                  open={mobileOpen}
                  onClose={handleDrawerToggle}
                  classes={{
                     paper: classes.drawerPaper
                  }}
                  ModalProps={{
                     keepMounted: true // Better open performance on mobile.
                  }}
               >
                  <MenuItems classes={classes} />
               </Drawer>
            </Hidden>
            <Hidden xsDown implementation="css">
               <Drawer
                  classes={{
                     paper: classes.drawerPaper
                  }}
                  variant="permanent"
                  open
               >
                  <MenuItems classes={classes} />
               </Drawer>
            </Hidden>
         </nav>
      </>
   );
};

const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
   root: {
      display: 'flex'
   },
   drawer: {
      [theme.breakpoints.up('sm')]: {
         width: drawerWidth,
         flexShrink: 0
      }
   },
   appBar: {
      [theme.breakpoints.up('sm')]: {
         width: `calc(100% - ${drawerWidth}px)`,
         marginLeft: drawerWidth
      }
   },
   menuButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
         display: 'none'
      }
   },
   // necessary for content to be below app bar
   toolbar: theme.mixins.toolbar,
   drawerPaper: {
      width: drawerWidth,
      position: 'relative',
      whiteSpace: 'nowrap',
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
      background: '#535454',
      color: '#fff',
      height: '100vh'
   },
   content: {
      flexGrow: 1,
      padding: theme.spacing(3)
   }
}));

export default AppMenu;
